import Uploader from "./uploader.vue";
import UploaderBtn from "./btn.vue";
import UploaderList from "./list.vue";
import { VueConstructor } from "vue";

const uploader = {
  install: (Vue: VueConstructor) => {
    Vue.component(Uploader.name, Uploader);
    Vue.component(UploaderBtn.name, UploaderBtn);
    Vue.component(UploaderList.name, UploaderList);
  }
};

export default uploader;
